import { Select } from "chakra-react-select";
import { useEffect, useState } from "react";
import { Favorites } from "../../../../interfaces/defaultInterfaces";
import FavoritesAPi from "../../../../services/favoritesApi";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { tipoPixState } from "../../../../atoms/tipoPixState";

interface SelectFavoriteProps {
  cliente: number;
  setFavorite: (favorite: Favorites) => void;
}

export default function SelectFavorite({ cliente, setFavorite }: SelectFavoriteProps) {
  const [favoriteList, setFavoriteList] = useState<Array<Favorites>>([]);
  const [search, setSearch] = useState<string>("");
  const tipoPix = useRecoilValue(tipoPixState); // Acesso ao tipoPix global

  async function getfavoriteList() {
    if (cliente !== 0) {
      try {
        const response = await FavoritesAPi.getFavorecidosList(
          1,
          50,
          cliente,
          search
        );
        setFavoriteList(response.data);
      } catch (error) {
        console.error("Erro ao buscar a lista de favorecidos:", error);
      }
    }
  }

  useEffect(() => {
    getfavoriteList();
  }, [cliente, search]);

  const clientOptions = favoriteList.map((client) => ({
    key: client.id,
    value: client.id,
    label: client.nomeTitular,
  }));

  function onChangeClientFilter(e: any) {
    const selectedClientId = Number(e.value);
    const favorecido = favoriteList.find(
      (item) => item.id === selectedClientId
    );

    if (favorecido) {
      setFavorite(favorecido);

      // Verifica se deve exibir o toast baseado no tipoPix global
      if (
        tipoPix === "CHAVE" &&
        (!favorecido.tipoChave || !favorecido.chavePix)
      ) {
        toast.error(
          "O favorecido selecionado não possui tipoChave e chavePix definidos."
        );
      }
    }
  }

  return (
    <Select
      focusBorderColor="blue.500"
      name="favorecidos"
      options={clientOptions}
      placeholder="Selecionar Favorecidos"
      closeMenuOnSelect={true}
      size="md"
      isSearchable={true} // Permite pesquisa
      onChange={(e: any) => onChangeClientFilter(e)}
      onInputChange={(e: string) => setSearch(e)} // Atualiza a pesquisa conforme o usuário digita
    />
  );
}
